
import InstanceBox from './index.vue';
import { dialog } from '@/plugins/dialog/index'
export default function (options) {
  return dialog({
    content() {
      return <InstanceBox options={options} />
    }
  })
}